import { LoggerService } from "./LoggerService";
import * as Sentry from "@sentry/react";

export class SentryLoggerService implements LoggerService {
  captureException(error: unknown, context?: Record<string, unknown>): void {
    Sentry.captureException(error, { extra: context });
  }

  captureMessage(message: string, context?: Record<string, unknown>): void {
    Sentry.captureMessage(message, { extra: context });
  }

  info(message: string, context?: Record<string, unknown>): void {
    Sentry.captureMessage(message, {
      level: "info",
      extra: context,
    });
  }

  warn(message: string, context?: Record<string, unknown>): void {
    Sentry.captureMessage(message, {
      level: "warning",
      extra: context,
    });
  }

  error(message: string, context?: Record<string, unknown>): void {
    Sentry.captureMessage(message, {
      level: "error",
      extra: context,
    });
  }
}
